module.exports = __webpack_public_path__ + "img/PSHeaderLogo.3b2e593f.svg";